module.exports = __webpack_public_path__ + "media/images/athletes/1753-5046eb8dbc25c646204ced198c8d025c.png";